<template>
    <div class="workersGroupDetails">
        <mediaCenter tabIndex="2"></mediaCenter>
        <div class="contentBox">
           <div :class="isMobile?'contentM':'content'">
                <p class="title">{{info.title}}</p>
                <div class="contents" v-html="info.content"></div>
           </div>
        </div>
    </div>
</template>

<script>
     import mediaCenter from '@/components/mediaCenter'
	const NEW_API_BASE = process.env.VUE_APP_NEW_API_URL || '/prod-api'
const newApi = (path) => NEW_API_BASE + path
export default {
		name:'mediaCenterd',
        components: {
            mediaCenter
        },
        data() {
            return {
                info:''
            }
        },
        mounted(){
           this.getInfo()
        },
       methods:{
         //获取行业资讯详情
         getInfo(){
            this.Request({
                url: newApi('/hzfglSys/news/public/detail/' + this.$route.query.id),
                    baseURL: '',
                method: 'get',
            }).then((res) => {
                this.info = res.data; if(this.info && this.info.content){var el=document.createElement("textarea");el.innerHTML=this.info.content;this.info.content=el.value}
            })
        }
       }
	}
</script>

<style scoped lang="less">
    .contentBox{
        background-color: #F7F8F9;
        padding: 42px 0;
    }
    .content{
        width: 1200px;
        margin: 0 auto;
        background-color: #fff;
        padding: 44px;
        border-radius: 3px;
    }
    .contentM{
        width: 100%;
        padding: 20px;
        background-color: #fff;
    }
    .title{
        margin-top: 13px;
        text-align: center;
        font-size: 21px;
        font-weight: bold;
    }
    .contents{
        margin-top: 64px;
    }
</style>
<style>
     .workersGroupDetails .contents img{
        max-width: 100% !important;
        height: auto !important;
        border-radius: 4px;
    }
</style>